/**
 * Etiquetas legibles para cables en selectores (código C-… + nombre + tipo).
 */

export type CableLike = {
  id: string
  codigo?: string | null
  nombre?: string | null
  tipo?: string | null
  numeroFibras?: number | null
}

/** Texto largo para <option> (distinguir muchos cables del mismo tipo). */
export function cableLabelForSelect(c: CableLike): string {
  const codigo = c.codigo?.trim() || ''
  const nombre = c.nombre?.trim() || ''
  const tipo = (c.tipo && String(c.tipo).trim()) || 'Cable'
  const fo = c.numeroFibras != null ? ` · ${c.numeroFibras} FO` : ''
  const parts: string[] = []
  if (codigo) parts.push(`[${codigo}]`)
  if (nombre) parts.push(nombre)
  parts.push(`${tipo}${fo}`)
  return parts.join(' ')
}

/** Texto más corto para guardar en config (cableNombre) o chips. */
export function cableLabelShort(c: CableLike): string {
  const codigo = c.codigo?.trim() || ''
  const nombre = c.nombre?.trim() || ''
  const tipo = (c.tipo && String(c.tipo).trim()) || 'Cable'
  if (codigo && nombre) return `${codigo} · ${nombre}`
  if (codigo) return `${codigo} (${tipo})`
  return nombre || tipo
}
